import React from "react";
import {InputProps} from "./wrapperComponents/Input";
import {FieldValues} from "react-hook-form/dist/types/fields";
import TooltipEx from "./Tooltip";

interface RadioInputProps<T extends FieldValues> extends InputProps<T> {
    label: string;
    tooltip?: React.ReactNode | string,
}

//https://tailwindcss.com/docs/hover-focus-and-other-states#arbitrary-peers per style disabled
// https://tailwindcss.com/docs/hover-focus-and-other-states#differentiating-peers per style diverso su opzione specifica
export function RadioInput<T extends FieldValues>(props: RadioInputProps<T>) {
    const {id, label, name, register, registerOptions, className, ...rest} = props;
    if (!register)
        throw new Error('Non hai specificato <register>!');
    return (

        /*
                <div className={`mb-2 truncate pl-1 pb-1 ${className}`}>
                    <input id={id} {...rest} {...register(name!, validation)} type="radio"
        */

        <div className={`mb-2 truncate pl-1 pb-1 ${className}`}>
            <input id={id} {...rest} {...register(name!, registerOptions)} type="radio"
                   className="peer is-disabled border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50"/>
            <TooltipEx tooltip={props.tooltip}>
                <label htmlFor={id} className="peer-[.is-disabled]:peer-disabled:opacity-50 pl-2 text-sm max-lg:text-xs">
                    {label}
                </label>
            </TooltipEx>
        </div>
    )
}

export default RadioInput;